import { Dictionary } from "../../../../util/collection/Dictionary";
import { SolidifyableData } from "../../../core/data/SolidifyableData";
import { GameConstants } from "../../controller/net/constant/GameConstants";
import { ResponsibleGamingOptionType } from "../enum/ResponsibleGamingOptionType";
import { ResponsibleGamingOptionData } from "./ResponsibleGamingOptionData";
/**
 * ResponsibleGamingSettingsData.ts
 */
export class ResponsibleGamingSettingsData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        this.solidifyOptions();
        this.hideInstructions = this.data.getBool(GameConstants.PROPERTY_HIDE_INSTRUCTIONS);
    }
    solidifyOptions() {
        this.options = new Dictionary();
        this.updateSetting(ResponsibleGamingOptionType.EXTRA_SPIN, GameConstants.PROPERTY_EXTRA_SPIN);
        this.updateSetting(ResponsibleGamingOptionType.SPIN_PRICE, GameConstants.PROPERTY_SPIN_PRICE);
        this.updateSetting(ResponsibleGamingOptionType.SINGLE_GAME_STAKE, GameConstants.PROPERTY_SINGLE_GAME_STAKE);
        this.updateSetting(ResponsibleGamingOptionType.MAXIMUM_LOSS, GameConstants.PROPERTY_MAXIMUM_LOSS);
    }
    updateSetting(type, name) {
        this.options.setValue(type, this.data.getNumber(name));
    }
    hasSetting(type) {
        return this.options.getValue(type) >= 0;
    }
    getSetting(type) {
        let value = this.options.getValue(type);
        return new ResponsibleGamingOptionData(type, value);
    }
    isHideInstructions() {
        return this.hideInstructions;
    }
    getSettings() {
        return this.data?.toObject() || null;
    }
}
//# sourceMappingURL=ResponsibleGamingSettingsData.js.map